/**
 * @prettier
 **/
import {
  columnSettings,
  defaultColumns
} from '@/angularBridgeCode/services/RingTreeService';

export default {
  widget: {
    iconClass: 'fa fa-gavel',
    title: ''
  },
  ringTrees: [],
  ringTreeReferences: {},
  checkReferencesText: '',
  columnSettings: columnSettings,
  userVisibleColumns: defaultColumns,
  status: {},
  currentTargets: []
};
